export default __webpack_public_path__ + "0b8a397017e273407c3ce36f09b938cd.png";